<template>
  <div class="card is-fullheight">
    <div class="card-image" v-on:click="cycleNote(aspect)">
      <figure class="image is-3by4 clue">
        <img :src="require(`../assets/aspects/${aspect}.jpeg`)" :alt="aspect" />
        <img
          :src="require(`../assets/${note}.png`)"
          v-if="note"
          :alt="note"
          class="noted"
        />
      </figure>
    </div>
    <footer class="card-footer" v-if="useTitles">
      <figcaption class="card-footer-item">
        {{ title }}
      </figcaption>
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Clue',
  props: {
    aspect: String,
  },

  computed: mapState('aspects', {
    title(state) {
      return state.aspects[this.aspect].title;
    },

    note(state) {
      return state.aspects[this.aspect].note;
    },

    useTitles: 'useTitles',
  }),

  methods: mapActions('aspects', ['cycleNote']),
};
</script>

<style scoped>
.clue {
  position: relative;
}
.noted {
  position: absolute;
  top: 80%;
  left: 20%;
}
.noted {
  display: inline;
}
figcaption {
  font-weight: bold;
  text-transform: capitalize;
}
</style>
